import { isNumber } from '../_util/defineType';
import { useCreation } from 'ahooks';
import React, { createContext, useReducer } from 'react';
import { currency } from '../_util/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const AmountGroupContext = /*#__PURE__*/createContext({});
const reducer = (state, action) => {
  switch (action.type) {
    case 'REMOVE_NUMBERS':
      delete state.allAmountNumbers[action.payload.key];
      break;
    case 'UPDATE_NUMBERS':
      state.allAmountNumbers = {
        ...state.allAmountNumbers,
        ...action.payload
      };
      break;
    default:
      break;
  }
  const addZero = Object.values(state.allAmountNumbers).reduce((result, num) => {
    if (isNumber(num)) {
      var _numStr$split$;
      const numStr = currency(num, state.propsCurrencyOptions);
      const decimalCount = (_numStr$split$ = numStr.split('.')[1]) === null || _numStr$split$ === void 0 ? void 0 : _numStr$split$.length;
      if (decimalCount !== undefined) {
        return Math.max(decimalCount, result !== null && result !== void 0 ? result : 0);
      }
    }
    return result;
  }, undefined);
  return {
    ...state,
    amountCurrencyOptions: {
      ...state.amountCurrencyOptions,
      addZero
    },
    allAmountNumbers: {
      ...state.allAmountNumbers
    }
  };
};
export const AmountGroup = props => {
  const {
    precision,
    addZero,
    mode,
    children
  } = props;
  const [state, updateState] = useReducer(reducer, {
    propsCurrencyOptions: {
      precision,
      addZero,
      mode
    },
    amountCurrencyOptions: {
      precision,
      addZero,
      mode
    },
    allAmountNumbers: {}
  });
  const contextValue = useCreation(() => {
    const value = {
      currencyOptions: state.amountCurrencyOptions,
      updateAmountNumbers: payload => {
        updateState({
          type: 'UPDATE_NUMBERS',
          payload
        });
      },
      removeAmountNumber: payload => {
        updateState({
          type: 'REMOVE_NUMBERS',
          payload
        });
      }
    };
    return value;
  }, [JSON.stringify(state.amountCurrencyOptions)]);
  return /*#__PURE__*/_jsx(AmountGroupContext.Provider, {
    value: contextValue,
    children: children
  });
};